/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The supported LTI version.
 */
export const LTIVersion = /* #__PURE__ */ parsers.exactly('v1_1', 'v1_3');
